import React, {Fragment} from 'react'
import Header from '../components/Header'
import Hero from '../components/Cookies/Hero'
import Content from '../components/Cookies/Content'
import Footer from '../components/Footer'

class Cookies extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        return(
            <Fragment>
                <Header logoColor="#46e2b9"  classStatic="" dropDownColor="black" title="Albert"/>
                <Hero/>
                <Content />
                <Footer/>
            </Fragment>
        )
    }
}

export default Cookies;